export class SaasRestoreItem {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "itemId",
            "baseName": "itemId",
            "type": "string",
            "format": ""
        },
        {
            "name": "isDirectory",
            "baseName": "isDirectory",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasRestoreItem.attributeTypeMap;
    }
    constructor() {
    }
}
